import React from 'react';
import { Popover, PopoverBody } from 'reactstrap';

class PopoverItem extends React.Component {
    constructor(props) {
        super(props);

        this.togglePopover = this.togglePopover.bind(this);
        this.state = {
            popoverOpen: false
        };
    }

    togglePopover() {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }

    render() {
        const { cursorPointer } = this.props.styles;

        return (
            <span>
                <span id={this.props.id} style={cursorPointer} onClick={this.togglePopover}>{(this.props.buttonText) ? this.props.buttonText : this.props.item}</span>
                <Popover placement="top" isOpen={this.state.popoverOpen} target={this.props.id} toggle={this.togglePopover}>
                    <PopoverBody>{this.props.item}</PopoverBody>
                </Popover>
            </span>
        );
    }
}

export default PopoverItem;


// WEBPACK FOOTER //
// ./src/components/common/PopoverItem.js